import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Timer = () => (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99992 15.1666C4.04659 15.1666 0.833252 11.9533 0.833252 7.99998C0.833252 4.04665 4.04659 0.833313 7.99992 0.833313C11.9533 0.833313 15.1666 4.04665 15.1666 7.99998C15.1666 11.9533 11.9533 15.1666 7.99992 15.1666ZM7.99992 1.83331C4.59992 1.83331 1.83325 4.59998 1.83325 7.99998C1.83325 11.4 4.59992 14.1666 7.99992 14.1666C11.3999 14.1666 14.1666 11.4 14.1666 7.99998C14.1666 4.59998 11.3999 1.83331 7.99992 1.83331Z"
      fill="#636370"
    />
    <path
      d="M5.99991 14.5H5.33325C5.05991 14.5 4.83325 14.2733 4.83325 14C4.83325 13.7267 5.04658 13.5067 5.31991 13.5C4.27325 9.92667 4.27325 6.07333 5.31991 2.5C5.04658 2.49333 4.83325 2.27333 4.83325 2C4.83325 1.72667 5.05991 1.5 5.33325 1.5H5.99991C6.15991 1.5 6.31325 1.58 6.40658 1.70667C6.49991 1.84 6.52658 2.00667 6.47325 2.16C5.21991 5.92667 5.21991 10.0733 6.47325 13.8467C6.52658 14 6.49991 14.1667 6.40658 14.3C6.31325 14.42 6.15991 14.5 5.99991 14.5Z"
      fill="#636370"
    />
    <path
      d="M10.0001 14.5C9.94677 14.5 9.89344 14.4933 9.8401 14.4733C9.5801 14.3866 9.43344 14.1 9.52677 13.84C10.7801 10.0733 10.7801 5.92664 9.52677 2.15331C9.4401 1.89331 9.5801 1.60664 9.8401 1.51998C10.1068 1.43331 10.3868 1.57331 10.4734 1.83331C11.8001 5.80664 11.8001 10.18 10.4734 14.1466C10.4068 14.3666 10.2068 14.5 10.0001 14.5Z"
      fill="#636370"
    />
    <path
      d="M8 11.4667C6.14 11.4667 4.28667 11.2067 2.5 10.68C2.49333 10.9467 2.27333 11.1667 2 11.1667C1.72667 11.1667 1.5 10.94 1.5 10.6667V10C1.5 9.84003 1.58 9.68669 1.70667 9.59336C1.84 9.50003 2.00667 9.47336 2.16 9.52669C5.92667 10.78 10.08 10.78 13.8467 9.52669C14 9.47336 14.1667 9.50003 14.3 9.59336C14.4333 9.68669 14.5067 9.84003 14.5067 10V10.6667C14.5067 10.94 14.28 11.1667 14.0067 11.1667C13.7333 11.1667 13.5133 10.9534 13.5067 10.68C11.7133 11.2067 9.86 11.4667 8 11.4667Z"
      fill="#636370"
    />
    <path
      d="M14 6.50001C13.9467 6.50001 13.8934 6.49334 13.84 6.47334C10.0734 5.22001 5.92002 5.22001 2.15335 6.47334C1.88669 6.56001 1.60669 6.42001 1.52002 6.16001C1.44002 5.89334 1.58002 5.61334 1.84002 5.52668C5.81335 4.20001 10.1867 4.20001 14.1534 5.52668C14.4134 5.61334 14.56 5.90001 14.4667 6.16001C14.4067 6.36668 14.2067 6.50001 14 6.50001Z"
      fill="#636370"
    />
  </svg>
)

export default withDefaultStyles(Timer)
